import tippy from 'tippy.js';

Drupal.behaviors.tooltips = {
  attach: function (context) {
    const tooltips = Array.from(context.getElementsByClassName('js-tooltip'));
    for (let index = 0; index < tooltips.length; index++) {
      const tooltip = tooltips[index];
      if (tooltip.classList.contains('is-loaded')) break;
      tippy(tooltip, {
        content(reference) {
          const id = reference.getAttribute('data-template');
          const title = reference.querySelector('title');
          if (title) title.remove();

          const template = document.getElementById(id);
          return template.innerHTML;
        },
        theme: 'carif',
        allowHTML: true,
        interactive: true,
        onMount: (instance) => {
          tooltip.classList.add('is-loaded');
          instance.popper.setAttribute('role', 'tooltip');
          instance.reference.setAttribute('aria-describedby', `tippy-${instance.id}`);
        },
        onHide: (instance) => {
          instance.reference.removeAttribute('aria-describedby');
        }
        // Dev option below to inspect tooltip
        // trigger: 'click',
        // hideOnClick: false
      });
    }

    window.addEventListener('keydown', (e) => {
      const activeElement = document.activeElement;
      if (['Escape', 'Enter'].includes(e.key) && activeElement.classList.contains('js-tooltip') && typeof activeElement._tippy === 'object') {
        const instance = activeElement._tippy;
        instance[e.key === 'Escape' ? 'hide' : 'show']();
      }
    })
  }
};


